module.exports = __webpack_public_path__ + "static/graph-requests-1010876b87f9ae280de88794d135613e.png";